import { useCSVDownloaderContext } from '../../stores/contexts/csv-download.context'

export const useCSVDownloader = () => {
  return useCSVDownloaderContext()
}
